import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown as FluentDropdown, makeStyles, mergeClasses, Option, useId } from "@fluentui/react-components";
import { useContext, useEffect, useState } from "react";
import { InfoLabel } from "./infoLabel";
import { ToolContext } from "../hoc/fluentToolWrapper";
const useDropdownStyles = makeStyles({
    dropdown: {
        minWidth: 0,
        width: "100%",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // align items vertically
    },
    dropdownText: { textAlign: "end", textOverflow: "ellipsis", whiteSpace: "nowrap", overflowX: "hidden" },
});
/**
 * Renders a fluent UI dropdown component for the options passed in, and an additional 'Not Defined' option if null is set to true
 * This component can handle both null and undefined values
 * @param props
 * @returns dropdown component
 */
export const Dropdown = (props) => {
    Dropdown.displayName = "Dropdown";
    const classes = useDropdownStyles();
    const { options, value } = props;
    const [defaultVal, setDefaultVal] = useState(props.value);
    const { size } = useContext(ToolContext);
    useEffect(() => {
        setDefaultVal(value);
    }, [props.value]);
    const id = useId("dropdown");
    const mergedClassName = mergeClasses(classes.container, props.className);
    const optionLabel = options.find((o) => o.value === defaultVal)?.label;
    return (_jsxs("div", { className: mergedClassName, children: [props.infoLabel && _jsx(InfoLabel, { ...props.infoLabel, htmlFor: id }), _jsx(FluentDropdown, { id: id, disabled: props.disabled, size: size, className: classes.dropdown, button: _jsx("span", { className: classes.dropdownText, children: optionLabel }), onOptionSelect: (evt, data) => {
                    const value = typeof props.value === "number" ? Number(data.optionValue) : data.optionValue;
                    if (value !== undefined) {
                        setDefaultVal(value);
                        props.onChange(value);
                    }
                }, selectedOptions: [defaultVal.toString()], value: optionLabel, children: options.map((option) => (_jsx(Option, { value: option.value.toString(), disabled: false, children: option.label }, option.label))) })] }));
};
export const NumberDropdown = Dropdown;
export const StringDropdown = Dropdown;
//# sourceMappingURL=dropdown.js.map